import EditTextComponent from './components/EditTextComponent'

import './App.css'

// Replace your code here
const App = () => <EditTextComponent />

export default App
